module.exports = __webpack_public_path__ + "img/snowflake-04.34c4a28a.png";